<template>
    <div id="app">
        <!-- <router-view></router-view> -->
        <router-view :key="$route.fullPath"></router-view>
        <!-- Cookie Consent Banner -->
        <transition name="slide-up">
            <div v-if="showCookieBanner" class="cookie-banner">
                <div class="cookie-content">
                    <p>
                        🍪 {{ $t('cookies.message') }}
                        <a href="/cookies-policy" target="_blank" class="cookie-link">{{ $t('cookies.policy_link')
                        }}</a> {{ $t('cookies.manage_preferences') }}
                    </p>
                    <div class="cookie-actions">
                        <button class="btn-accept" @click="acceptCookies">{{ $t('cookies.accept') }}</button>
                        <button class="btn-decline" @click="declineCookies">{{ $t('cookies.decline') }}</button>
                        <button class="btn-customize" @click="openCustomize">{{ $t('cookies.customize') }}</button>
                    </div>
                </div>
            </div>
        </transition>
        <!-- Cookie Customize Modal -->
        <transition name="slide-up">
            <div v-if="showCustomize" class="cookie-modal">
                <div class="cookie-modal-content">
                    <div class="cookie-modal-header">
                        <h3>{{ $t('cookies.manage_title') }}</h3>
                    </div>

                    <div class="cookie-modal-body">
                        <p>{{ $t('cookies.select_text') }}</p>

                        <label>
                            <input type="checkbox" checked disabled />
                            {{ $t('cookies.essential') }}
                        </label>
                        <label>
                            <input type="checkbox" v-model="preferences.analytics" />
                            {{ $t('cookies.analytics') }}
                        </label>
                        <label>
                            <input type="checkbox" v-model="preferences.marketing" />
                            {{ $t('cookies.marketing') }}
                        </label>
                    </div>

                    <div class="cookie-actions">
                        <button class="btn-accept" @click="savePreferences">{{ $t('cookies.save') }}</button>
                        <button class="btn-decline" @click="showCustomize = false">{{ $t('cookies.cancel') }}</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { computed, watchEffect } from "@vue/runtime-core";
import Cookies from "js-cookie";
import API from "@/api";

export default {
    name: 'app',
    components: {},
    data() {
        return {
            loadHorizontal: true,
            loadVertical: false,
            showCookieBanner: false,
            showCustomize: false,
            preferences: {
                analytics: false,
                marketing: false,
            },
        }
    }, created() {
    }, watch: {
        $route(to, from) {
            if (to.name == 'citizen') {
                this.loadHorizontal = false;
            } else {
                this.loadVertical = true;
                // import(`./public/assets/scss/style`);
                // import(`./public/assets/css/custom.css`);
            }
        }
    }, mounted() {
        const cookieConsent = Cookies.get("cookie_preferences");
        if (!cookieConsent) {
            this.showCookieBanner = true;
        } else {
            this.preferences = JSON.parse(cookieConsent);
        }
        window.addEventListener('message', this.handleGlobalMessage);

    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleGlobalMessage);
    },
    head: {
        link: [
            // { rel: 'favicon', href: 'public/assets/images/dashboard-icon-01.png', id: 'favicon' },
            { rel: 'icon', href: require('@/public/assets/favicon-32x32.png') } // Path to your favicon
        ]
    },
    methods: {
        handleGlobalMessage(event) {

            if (event.origin !== window.location.origin) return;
            const providerMap = {
                'GOOGLE_CODE_SUCCESS': 'google',
                'FACEBOOK_CODE_SUCCESS': 'facebook',
            };
            const provider = providerMap[event.data.type];

            if (!provider) {
                // console.warn("Unknown message type:", event.data.type);
                return;
            }

            const code = event.data.code;
            const data = {
                provider: provider,
                accessToken: code
            };

            API.socialLogin(
                data,
                (response) => {
                    if (response.token) {
                        // Success! Save to local storage
                        localStorage.setItem('isLoggedin', response.token);
                        localStorage.setItem('user', JSON.stringify(response.user));
                        localStorage.setItem('isAuthenticatedToAccessWebsite', 'true');

                        // Redirect to home
                        window.location.href = '/';
                    } else {
                        console.error(`${provider} login failed: No token returned`);
                        alert(`${provider.charAt(0).toUpperCase() + provider.slice(1)} login failed`);
                    }
                },
                (error) => {
                    console.error(`${provider} login failed`, error);
                    alert(`${provider.charAt(0).toUpperCase() + provider.slice(1)} login failed`);
                }
            );
        },
        acceptCookies() {
            const allPreferences = { analytics: true, marketing: true };
            Cookies.set("cookie_preferences", JSON.stringify(allPreferences), {
                expires: 7,
            });
            this.preferences = allPreferences;
            this.showCookieBanner = false;
        },
        declineCookies() {
            const essentialsOnly = { analytics: false, marketing: false };
            Cookies.set("cookie_preferences", JSON.stringify(essentialsOnly), {
                expires: 7,
            });
            this.preferences = essentialsOnly;
            this.showCookieBanner = false;
        },
        openCustomize() {
            this.showCustomize = true;
        },
        savePreferences() {
            Cookies.set("cookie_preferences", JSON.stringify(this.preferences), {
                expires: 7,
            });
            this.showCustomize = false;
            this.showCookieBanner = false;
        },
    },
}
</script>
<style lang="scss">
@import "../node_modules/@mdi/font/css/materialdesignicons.min.css";
@import "../node_modules/flag-icon-css/css/flag-icon.min.css";
@import "../node_modules/font-awesome/css/font-awesome.min.css";
@import "../node_modules/simple-line-icons/css/simple-line-icons.css";
@import "../node_modules/ti-icons/css/themify-icons.css";
@import "../node_modules/sweetalert2/dist/sweetalert2.min.css";
@import "../node_modules/vue-snotify/styles/material.css";
@import "../node_modules/codemirror/lib/codemirror.css";
@import "../node_modules/fullcalendar/dist/fullcalendar.css";
@import "../node_modules/c3/c3.min.css";
@import "../node_modules/chartist/dist/chartist.min.css";
@import "./public/assets/scss/style";
@import "./front_public/assets/scss/style.scss";
@import "./public/assets/css/custom.css";



@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-calendars/styles/material.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-schedule/styles/material.css";


/* Animation */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.4s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}

/* Full-width cookie banner */
.cookie-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    // background-color: #70d3ff;
    background: #ffffff;
    border-top: 1px solid #e5e5e5;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
    padding: 15px 20px;
    z-index: 9999;
    font-family: "Poppins", sans-serif;
}

/* Align text + buttons */
.cookie-content {
    max-width: 1200px;
    /* matches your site width */
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.cookie-content p {
    margin: 0;
    font-size: 14px;
    color: #333;
    line-height: 1.5;
}

.cookie-link {
    color: #70d3ff;
    font-weight: 500;
    text-decoration: none;
}

.cookie-link:hover {
    text-decoration: underline;
    color: #4cc1f4;
}

/* Buttons */
.cookie-actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;

    @media (min-width: 768px) {
        margin-top: 0;
    }
}

.btn-accept {
    background: #70d3ff;
    border: none;
    color: #fff;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.btn-accept:hover {
    background: #4cc1f4;
}

.btn-decline {
    background: #f5f5f5;
    border: 1px solid #ddd;
    color: #555;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.btn-decline:hover {
    background: #e0e0e0;
}

.btn-customize {
    background: #ffffff;
    border: 1px solid #70d3ff;
    color: #70d3ff;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease, color 0.3s ease;
}

.btn-customize:hover {
    background: #70d3ff;
    color: #ffffff;
}

/* Customize modal matches bar style */
.cookie-modal {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    border-top: 1px solid #e5e5e5;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
    z-index: 10000;
    font-family: "Poppins", sans-serif;
    padding: 20px;
}

.cookie-modal-content {
    max-width: 1200px;
    /* match site container */
    margin: 0 auto;
}

.cookie-modal-header h3 {
    margin: 0 0 10px;
    font-size: 18px;
    color: #333;
}

.cookie-modal-body {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    label {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        cursor: pointer;
    }

    input[type="checkbox"] {
        transform: scale(1.1);
    }
}

/* Reuse cookie-actions style */
.cookie-actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;

    @media (min-width: 768px) {
        justify-content: flex-end;
        margin-top: 0;
    }
}
</style>
